import { Button } from "./ui/button";
import { PlayCircle } from "lucide-react";

const Hero = () => (
  <section className="w-full max-w-5xl mx-auto pt-20 pb-16 px-4 text-center">
    <div className="mb-8 flex flex-col items-center gap-4">
      <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-xs rounded-full font-semibold mb-2 dark:bg-teal-900 dark:text-teal-200 transition">NEW FEATURE: AI Video Magic ✨</span>
      <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight leading-tight bg-gradient-to-tr from-teal-500 via-blue-600 to-blue-300 bg-clip-text text-transparent mb-4">
        Create. Edit. Shine.<br className="hidden md:inline" /> The All‑in‑One Video Editor
      </h1>
      <p className="max-w-2xl mx-auto text-lg md:text-2xl text-muted-foreground mb-6">
        Instantly craft stunning videos with powerful tools and effortless workflows. No downloads. No complexity. Just creativity.
      </p>
      <Button size="lg" className="mt-2 px-8 py-5 text-lg font-bold shadow-lg hover:scale-105 transition-transform">
        <PlayCircle className="w-5 h-5 mr-2" /> Try Free
      </Button>
    </div>
    <div className="w-full flex justify-center">
      <div className="rounded-xl overflow-hidden shadow-2xl ring-2 ring-teal-200 dark:ring-blue-400/40  bg-background/80">
        <img
          src="https://images.pexels.com/photos/3990842/pexels-photo-3990842.jpeg?auto=compress&w=900&q=80"
          alt="App interface preview"
          className="w-full max-w-3xl h-64 object-cover object-center"
        />
      </div>
    </div>
  </section>
);

export default Hero;
